/**
 * @fileoverview UI module events.
 */

import { EVENT_PREFIX } from "../../core/events";

/**
 * UI state events.
 */
export const UI_EVENTS = {
  /** Set loading state */
  LOADING: `${EVENT_PREFIX}ui.loading`,
  /** Set breadcrumbs visibility state */
  BREADCRUMBS: `${EVENT_PREFIX}ui.breadcrumbs`,
  /** Show toast notification */
  TOAST: `${EVENT_PREFIX}ui.toast`,
  /** Show confirm dialog (async request) */
  CONFIRM: `${EVENT_PREFIX}ui.confirm`,
  /** Confirm dialog response (from host) */
  CONFIRM_RESPONSE: `${EVENT_PREFIX}ui.confirm.response`,
} as const;
